import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { InternalTransfer } from '../../details'
import { RollbackInternalTransfer } from './types'
import { transactionRequestStatus } from '../../../const'
import { internalTransferMounted } from '../../list/model'

export const mounted = createEvent()
export const unmounted = createEvent()
export const setRollback = createEvent<string>()
export const $rollback = restore<string>(setRollback, '')
export const submitRollback = createEvent<RollbackInternalTransfer>()
export const rollbackTransactionRequest = fx<
  RollbackInternalTransfer,
  InternalTransfer
>({
  method: 'PUT',
  url: `/internal_transfer/`,
})

sample({
  clock: submitRollback,
  fn: ({ requestId, rollbackReason }) => {
    return {
      body: {
        requestId: requestId,
        status: transactionRequestStatus.rollback(),
        rollbackReason: rollbackReason,
      },
      url: `/internal_transfer/${requestId}`,
    }
  },
  target: rollbackTransactionRequest,
})

// clear field on success

sample({
  clock: rollbackTransactionRequest.done,
  fn: () => ({}),
  target: [internalTransferMounted],
})
